import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HighchartsService {

  constructor() { }

  drawCompareBars(data: any) {
    return {
      chart: {
        type: 'column',
      },
      title: {
        text: '',
      },
      plotOptions: {
        series: {
          //@ts-ignore
          grouping: false,
          borderWidth: 0,
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        shared: true,
        headerFormat: '<span style="font-size: 15px">{point.point.name}</span><br/>',
        pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
      },
      xAxis: {
        type: 'category',
        labels: {
          useHTML: true,
          animate: true,
          formatter: function() {
            const value = this.value;
            let output = '';

            data.data.forEach((el) => {
              if (data.secondcCoincidenceToFindLogo) {
                if (`${el[data.coincidenceToFindLogo]} - ${el[data.secondcCoincidenceToFindLogo]}` === value) {
                  output = el.logo;
                }
              } else if (el[data.coincidenceToFindLogo] === value) {
                output = el.logo;
              }
            });

            return '<span>' +
              '<img src="' + output + '" style="width: 40px; height: 40px;"/><br>' +
              '</span>';
          },
        },
      },
      yAxis: [{
        title: {
          text: '# Requisitos legales',
        },
        showFirstLabel: false,
      }],
      series: [
        //@ts-ignore
        {
          color: 'rgb(158, 159, 163)',
          pointPlacement: -0.2,
          linkedTo: 'main',
          data: data.prevData,
          name: 'Total',
        },
        //@ts-ignore
        {
          name: 'Entregados',
          id: 'main',
          dataSorting: {
            enabled: true,
            matchByName: true,
          },
          dataLabels: [
            {
              enabled: true,
              inside: true,
              style: {
                fontSize: '16px',
              },
            },
          ],
          data: data.currentData,
        }],
      exporting: {
        allowHTML: true,
      },
    };
  }

  drawLogbooksBars(data: any) {
    return {
      chart: {
        type: 'bar',
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: data.stationNames,
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
      },
      legend: {
        reversed: true,
      },
      plotOptions: {
        series: {
          stacking: 'normal',
        },
      },
      series: data.series,
    };
  }
}
